import { zodResolver } from '@shared/utils';
import { FormProvider, useForm } from 'react-hook-form';

import { useQuestionCreationTaskDetails } from '../../providers';
import {
  ChangeAssigneeFormModal,
  ChangeAssigneeModalSchema,
  type ChangeAssigneeModalFormValues,
} from '../change-assignee-form-modal';

interface ChangeAssigneeModalProps {
  open: boolean;
  onClose: () => void;
}

export default function ChangeAssigneeModal(props: Readonly<ChangeAssigneeModalProps>) {
  const { open, onClose } = props;

  const {
    task: { assignee },
  } = useQuestionCreationTaskDetails();

  const formContext = useForm<ChangeAssigneeModalFormValues>({
    resolver: zodResolver(ChangeAssigneeModalSchema),
    defaultValues: {
      assignee: assignee
        ? {
            label: `${assignee.firstname} ${assignee.lastname}`,
            value: assignee.id,
          }
        : undefined,
    },
  });

  return (
    <FormProvider {...formContext}>
      <ChangeAssigneeFormModal open={open} onClose={onClose} />
    </FormProvider>
  );
}
